/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessDto } from '../../models/kyc-process-dto';
import { KycProcessReopenRequestDto } from '../../models/kyc-process-reopen-request-dto';

export interface ReopenProcess$Params {
  id: string;
      body: KycProcessReopenRequestDto
}

export function reopenProcess(http: HttpClient, rootUrl: string, params: ReopenProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessDto>> {
  const rb = new RequestBuilder(rootUrl, reopenProcess.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessDto>;
    })
  );
}

reopenProcess.PATH = '/kyc/processes/{id}/reopen';
